import { MENU_NAVIGATION, POWER_RANKINGS_SUB_MENU, SCREENS } from "../constants/constants";

export const powerRankingsTabToScreenId = (tab, checked) => {
    if (tab === POWER_RANKINGS_SUB_MENU.rating) {
        if (!checked) {
            return SCREENS.POWER_RANKINGS.BEST_RATING;
        }
        return SCREENS.POWER_RANKINGS.WORST_RATING;
    } else if (tab === POWER_RANKINGS_SUB_MENU.points) {
        if (!checked) {
            return SCREENS.POWER_RANKINGS.BEST_POINTS;
        }
        return SCREENS.POWER_RANKINGS.WORST_POINTS;
    } else if (tab === POWER_RANKINGS_SUB_MENU.coins) {
        if (!checked) {
            return SCREENS.POWER_RANKINGS.BEST_COINS;
        }
        return SCREENS.POWER_RANKINGS.WORST_COINS;
    } else if (tab === POWER_RANKINGS_SUB_MENU.winsCount) {
        return SCREENS.POWER_RANKINGS.WINS_COUNT;
    } else if (tab === POWER_RANKINGS_SUB_MENU.winPercentage) {
        return SCREENS.POWER_RANKINGS.WIN_PERCENTAGE;
    } else if (tab === POWER_RANKINGS_SUB_MENU.lossCount) {
        return SCREENS.POWER_RANKINGS.LOSS_COUNT;
    } else if (tab === POWER_RANKINGS_SUB_MENU.lossPercentage) {
        return SCREENS.POWER_RANKINGS.LOSS_PERCENTAGE;
    }

    return null;
}

export const buyPageTabToScreenId = (tab) => {
    if (tab === MENU_NAVIGATION.buyPage || tab === MENU_NAVIGATION.buyPageMoneyPacks) {
        return SCREENS.SHOP.MONEY_PACKS;
    } else if (tab === MENU_NAVIGATION.buyPagePremiumPacks) {
        return SCREENS.SHOP.PREMIUM_PACKS;
    } else if (tab === MENU_NAVIGATION.tournamentTickets) {
        return SCREENS.SHOP.TOURNAMENT_TICKETS;
    } else if (tab === MENU_NAVIGATION.buyPageHistory) {
        return SCREENS.SHOP.TRANSACTION_HISTORY;
    } else if (tab === MENU_NAVIGATION.buyPageRedeemCode) {
        return SCREENS.SHOP.REDEEM_CODE;
    }
    return null;
}